import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { EICFConsentsApi } from '../../../apis/EICFApi/EICFConsentsApi.ts';

export function useGetCanSignEICF(enabled: boolean = true) {
    return useQuery({
        queryKey: [QueryKeys.eicfCanSign],
        queryFn: () => EICFConsentsApi.canSign(),
        enabled,
    });
}
